<template>
  <Main :purchaseMaterialCode="purchaseMaterialCode" :disabled="disabled" />
</template>

<script>
import Main from './main'

export default {
  name: 'DetailTableIndex',
  components: {
    Main,
  },
  props: {
    purchaseMaterialCode: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
